import RobotsTxtFA from './fa/fa.json'

const RobotsTxtMessages = {
  fa: { ...RobotsTxtFA },
}

export default RobotsTxtMessages
